import { Injectable } from '@angular/core';
import { datadogRum } from '@datadog/browser-rum';

export interface User {
  username: string;
  name: string;
  lastName: string;
  email: string;
  id: string;
}

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private user: User | null = null;

  login(username: string) {
    
    // Aquí normalmente iría una lógica para login, pero insertaremos un usuario como placeholder
    if (username === 'test') {
      this.user = {
        username: 'test',
        name: 'test',
        lastName: 'test',
        email: 'test@test.com',
        id: '1'
      };
      const datadogUser = {
        id: this.user.id,
        name: `${this.user.name} ${this.user.lastName}`,
        email: this.user.email,
      }

      datadogRum.setUser(datadogUser)
    } else {
      this.user = null; // Resetea el objeto user si no es el usuario "test"
    }
  }

  getUser(): User | null {
    return this.user;
  }

  getUsername(): string | null {
    return this.user ? this.user.username : null;
  }
}
